import type { AxiosRequestHeaders } from 'axios'

export default function authHeader(): AxiosRequestHeaders {
	const userJson = localStorage.getItem('user')
	if (userJson !== null) {
		const user = JSON.parse(userJson)
		if (user && user.access_token) {
			return { Authorization: user.access_token }
		}
	}
	return {}
}
